import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import NavMenu from "./components/NavMenu";
import LoginModal from "../component/LoginModal";
import RegisterModal from "../component/RegisterModal";
import ForgotPassword from "../component/ForgotPassword";

export default function Header(props) {
  const { isAuthenticated, userType, userDetails, userLogout } = useContext(AuthContext);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isActive = (path) => {
    return location.pathname + location.search === path ? "active" : "";
  };

  useEffect(() => {
    if (isAuthenticated) {
      try {
        $("#sign_up_popup2").modal("hide");
        $("#sign_up_popup3").modal("hide");
        $(".modal-backdrop").remove();
        $("body").removeClass("modal-open");
        $("body").removeAttr("style");
      } catch (error) {
        // console.log(error);
      }
    }
  }, [isAuthenticated]);

  return (
    <React.Fragment>
      <header className={`site-header header-style-3 fixed mobile-sider-drawer-menu ${isMobileMenuOpen ? "active" : ""}`}>
        <div className="sticky-header main-bar-wraper  navbar-expand-lg is-fixed">
          <div className="main-bar">
            <div className="container clearfix">
              <div className="logo-header">
                <div className="logo-header-inner logo-header-one">
                  <Link to={"/"}>
                    <img src="portal/images/CompanyLogo.png" alt=" abcd"></img>
                  </Link>
                </div>
              </div>
              <NavMenu isMobileMenuOpen={isMobileMenuOpen} setIsMobileMenuOpen={setIsMobileMenuOpen} />
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Sidebar Navigation Overlay */}
      {windowWidth <= 992 && (
        <React.Fragment>
          <div
            className={`mobile-sidebar-overlay ${isMobileMenuOpen ? "active" : ""}`}
            onClick={() => setIsMobileMenuOpen(false)}
          ></div>

          {/* Mobile Left Slide Sidebar Navigation Drawer */}
          <div className={`mobile-sidebar ${isMobileMenuOpen ? "active" : ""}`}>
            <div className="mobile-sidebar-header">
              <h4>Menu</h4>
              <button
                className="mobile-sidebar-close"
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Close Menu"
              >
                <i className="ri-close-line"></i>
              </button>
            </div>

            <div className="mobile-sidebar-body">
              <ul className="mobile-sidebar-nav">
                <li>
                  <Link
                    className={isActive("/job_search")}
                    to="/job_search"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-home-line"></i> Explore Jobs
                  </Link>
                </li>
                <li>
                  <Link
                    className={isActive("/blog")}
                    to="/blog"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-article-line"></i> Blogs
                  </Link>
                </li>
                <li>
                  <Link
                    className={isActive("/training")}
                    to="/training"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-book-open-line"></i> Training
                  </Link>
                </li>
                {/* <li>
                  <Link
                    className={isActive("/faq")}
                    to="/faq"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-questionnaire-line"></i> FAQ
                  </Link>
                </li> */}
                <li>
                  <Link
                    className={isActive("/contact-us")}
                    to="/contact-us"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <i className="ri-contacts-line"></i> Contact
                  </Link>
                </li>

                {!isAuthenticated ? (
                  <React.Fragment>
                    <li className="mobile-sidebar-divider"></li>
                    <li>
                      <Link
                        className={isActive("/login-seeker")}
                        to="/login-seeker"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        <i className="ri-briefcase-line"></i> Login
                      </Link>
                    </li>
                    <li>
                      <Link
                        className={isActive("/register-seeker")}
                        to="/register-seeker"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        <i className="ri-login-box-line"></i> Sign Up
                      </Link>
                    </li>
                    <li className="mobile-sidebar-emp-zone">
                      <Link
                        to="/employer-zone"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        Employer Zone
                      </Link>
                    </li>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <li className="mobile-sidebar-divider"></li>
                    <li className="mobile-sidebar-user-welcome">
                      <span>Welcome, <strong>{userType === "seeker" ? (userDetails?.first_name || userDetails?.username) : (userDetails?.comp_name || userDetails?.username)}</strong></span>
                    </li>
                    {userType === "seeker" ? (
                      <React.Fragment>
                        <li>
                          <Link
                            className={isActive("/job_search")}
                            to="/job_search"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-search-line"></i> Search Jobs
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=dashboard")}
                            to="/profile?tab=dashboard"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-dashboard-3-line"></i> Dashboard
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=myProfile")}
                            to="/profile?tab=myProfile"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-profile-line"></i> My Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=editProfile")}
                            to="/profile?tab=editProfile"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-edit-2-line"></i> Edit Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=myDocuments")}
                            to="/profile?tab=myDocuments"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-file-list-3-line"></i> My Documents
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=appliedJobs")}
                            to="/profile?tab=appliedJobs"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-suitcase-line"></i> Applied Jobs
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=matchedJobs")}
                            to="/profile?tab=matchedJobs"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-suitcase-line"></i> Matched Jobs
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=savedJobs")}
                            to="/profile?tab=savedJobs"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-save-line"></i> Saved Jobs
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=changeSettings")}
                            to="/profile?tab=changeSettings"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-settings-3-line"></i> Settings
                          </Link>
                        </li>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <li>
                          <Link
                            className={isActive("/profile?tab=dashboard")}
                            to="/profile?tab=dashboard"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-dashboard-3-line"></i> Dashboard
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=myProfile")}
                            to="/profile?tab=myProfile"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-profile-line"></i> Company Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=editProfile")}
                            to="/profile?tab=editProfile"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-edit-2-line"></i> Edit Profile
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=manageJob")}
                            to="/profile?tab=manageJob"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-suitcase-line"></i> My Jobs
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=postJob")}
                            to="/profile?tab=postJob"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri-save-line"></i> Post A Job
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=applicantPage")}
                            to="/profile?tab=applicantPage"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-user-line"></i> Applicants
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=analyticsPage")}
                            to="/profile?tab=analyticsPage"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-line-chart-line"></i> Analytics
                          </Link>
                        </li>
                        <li>
                          <Link
                            className={isActive("/profile?tab=changeSettings")}
                            to="/profile?tab=changeSettings"
                            onClick={() => setIsMobileMenuOpen(false)}
                          >
                            <i className="ri ri-settings-3-line"></i> Setting
                          </Link>
                        </li>
                      </React.Fragment>
                    )}
                    <li className="mobile-sidebar-logout">
                      <a
                        href="#"
                        onClick={async (e) => {
                          e.preventDefault();
                          await userLogout();
                          setIsMobileMenuOpen(false);
                        }}
                      >
                        <i className="ri-logout-box-line"></i> Sign out
                      </a>
                    </li>
                  </React.Fragment>
                )}
              </ul>
            </div>
          </div>
        </React.Fragment>
      )}

      {!isAuthenticated ? (
        <React.Fragment>
          <LoginModal />
          <RegisterModal />
          <ForgotPassword />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}
